/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Role title for the lecturer (e.g., 'Oral Examiner', 'Workshop Lead'). If None, defaults to label.
 */
export type EventKindLecturerRoleLabel = string | null;
